/* eslint-disable */ 
import React, { useState ,useEffect} from "react";
import { logo } from "../_components/Imagepath";
import ForgotPasswordNotifications from "./ForgotPasswordNotifications";
import { useTranslation } from "react-i18next";

const PasswordResetNotifications = (props) => {
const { t } = useTranslation();
  return (
    <>
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <img
              className="img-fluid logo-dark mb-2"
              src={logo}
              alt="Logo"
            />
            <div className="loginbox">
              <div className="login-right">
                <div className="login-right-wrap">
                  <h1>{t("Password Reset Successful")}</h1>
                  <br></br>
                  <p className="text-center">
                    {t("Your password has been reset successfully. You can now log in with your new password")}
                  </p>
                  <p className="text-center">
                    <a href="https://crm.kflow.cloud/login">{t("Go to Login Page")}</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PasswordResetNotifications;
